<div class="flex flex-col text-red-600">
  <ng-content />
</div>
